var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import styled from 'styled-components';
import { Divider, LinearProgress, IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { salesContract as api } from '../../../api';
import { useRequest } from '../../../hooks/requestHook';
import PageLayout from '../../atoms/PageLayout';
import Button from '../../atoms/BaseButton';
import DownloadIconWithText from '../../atoms/DownloadIconWithtext';
import SalesContractForm from './SalesContractForm';
import SalesContractItemTable from './SalesContractItemTable';
import { useParams, useNavigate } from 'react-router-dom';
import useDownload from '../../../hooks/useDownload';
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 0 24px;\n"], ["\n  padding: 0 24px;\n"])));
var TableContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding-bottom: 20px;\n"], ["\n  padding-bottom: 20px;\n"])));
var ButtonWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: 0 10px;\n"], ["\n  padding: 0 10px;\n"])));
var ActionWrapper = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n\n  .MuiIconButton-root {\n    .MuiTypography-root {\n      font-size: 9px;\n    }\n\n    svg {\n      font-size: 32px;\n    }\n  }\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n\n  .MuiIconButton-root {\n    .MuiTypography-root {\n      font-size: 9px;\n    }\n\n    svg {\n      font-size: 32px;\n    }\n  }\n"])));
var AdminSalesContractDetailPage = function () {
    var _a = useParams().id, id = _a === void 0 ? '' : _a;
    var t = useTranslation().t;
    var get = useRequest(api.get);
    var navigate = useNavigate();
    var _b = React.useState(true), loading = _b[0], setLoading = _b[1];
    var _c = React.useState(), salesContract = _c[0], setSalesContract = _c[1];
    var _d = React.useState([]), salesContractItems = _d[0], setSalesContractItems = _d[1];
    var salesContractDownload = useDownload({
        path: "/api/sales_contracts/".concat(id, ".pdf"),
        downloadFilename: "sales_contract_#".concat(id, ".pdf"),
    });
    var auctionBonusInvoiceDownload = useDownload({
        path: "/api/sales_contracts/".concat(id, "/auction_bonus_invoice.pdf"),
        downloadFilename: "auction_bonus_invoice_#".concat(id, ".pdf"),
    });
    var hasAuctionOffer = React.useMemo(function () { return salesContractItems.some(function (item) { return item.orderType === 'auction'; }); }, [salesContractItems]);
    React.useEffect(function () {
        var canceled = false;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        return [4 /*yield*/, get(id)];
                    case 1:
                        response = _a.sent();
                        if (canceled)
                            return [2 /*return*/];
                        setLoading(false);
                        if (!response)
                            return [2 /*return*/];
                        setSalesContract(response);
                        setSalesContractItems(response.items);
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            canceled = true;
        };
    }, [id, get]);
    var handleUpdateSalesContractItem = React.useCallback(function (salesContractItem) {
        var nextItems = salesContractItems.map(function (item) {
            return item.id === salesContractItem.id ? salesContractItem : item;
        });
        setSalesContractItems(nextItems);
    }, [salesContractItems]);
    var handleUpdateSalesContract = React.useCallback(function (salesContract) {
        setSalesContract(salesContract);
        setSalesContractItems(salesContract.items);
    }, []);
    if (loading || !salesContract)
        return React.createElement(LinearProgress, null);
    return (React.createElement(PageLayout, { title: t('pages.adminSalesContractAndAuctionBonusInvoice.title'), backLink: true, actions: React.createElement(React.Fragment, null,
            React.createElement(ActionWrapper, null,
                React.createElement(IconButton, { onClick: salesContractDownload.handleDownload, disabled: salesContractDownload.downloading },
                    React.createElement(DownloadIconWithText, { title: "Sales Contract" })),
                hasAuctionOffer && (React.createElement(IconButton, { onClick: auctionBonusInvoiceDownload.handleDownload, disabled: auctionBonusInvoiceDownload.downloading },
                    React.createElement(DownloadIconWithText, { title: "Auction Bonus Invoice" })))),
            salesContract.producerBankAccount && (React.createElement(ButtonWrapper, null,
                React.createElement(Button, { onClick: function () {
                        return navigate("/admin/sales_contracts/".concat(salesContract.id, "/bank_account"));
                    }, color: "primary" }, t('buttons.bankAccount')))),
            salesContract.status === 'published' &&
                salesContract.offerList.roaster &&
                Boolean(salesContract.offerList.salesRewardRate) && (React.createElement(ButtonWrapper, null,
                React.createElement(Button, { onClick: function () {
                        return navigate("/admin/sales_contracts/".concat(salesContract.id, "/roaster_sales_reward"));
                    }, color: "primary" }, t('buttons.salesReward'))))) },
        React.createElement(Container, null,
            React.createElement(SalesContractForm, { disabled: salesContract.status === 'published', salesContract: salesContract, onUpdate: handleUpdateSalesContract })),
        React.createElement(Divider, null),
        React.createElement(TableContainer, null,
            React.createElement(SalesContractItemTable, { editable: salesContract.status === 'draft', salesContractItems: salesContractItems, onUpdate: handleUpdateSalesContractItem }))));
};
export default AdminSalesContractDetailPage;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
